import React from 'react'
import { Grid, Button, Paper, Table, TableHead, TableCell, TableBody } from '@material-ui/core'
import { connect } from 'react-redux'
import {
  GET_QUANTITY_TYPES,
  GET_COMPONENT_GROUPS,
  UPDATE_COMPONENT_GROUP,
  ADD_COMPONENT_GROUP,
  DELETE_COMPONENT_GROUP,
} from './GraphQL'
import { useQuery, useLazyQuery, useMutation } from '@apollo/react-hooks'
import { startLoading, stopLoading } from '../../../actions/loading'
import { hasAccess } from '../../../utils/api'
import { formatErrors } from '../../../utils/common'

import ComponentGroupListItem from './ComponentGroupListItem'
import EditableHOCWrapper from '../../../containers/HOC/EditableHOC'

import { openErrorMessage, openSuccessMessage } from '../../../actions/message'
import AddComponentGroupModal from '../../../components/Modal/AddComponentGroupModal'
import ContainerWithTitle from '../../../containers/HOC/ContainerWithTitle'
import ModalDialog from '../../../components/common/ModalDialog'

const ComponentGroupListItemEditable = EditableHOCWrapper(ComponentGroupListItem)

let columns = ['Name', 'Quantity Type', 'Status', '']

const ComponentGroups = (props) => {
  const permitted = hasAccess()
  const addComponentGroupModal = React.useRef(null)
  const deleteModal = React.useRef(null)
  const [componentGroupList, setComponentGroupList] = React.useState([])
  const [isUpdateCompleted, setIsUpdateCompleted] = React.useState(false)
  const [selectedItemToDelete, setSelectedItemToDelete] = React.useState({})
  const [quantityTypeList, setQuantityTypeList] = React.useState([])

  // eslint-disable-next-line no-unused-vars
  const resQuantityTypes = useQuery(GET_QUANTITY_TYPES, {
    onCompleted: (data) => {
      setQuantityTypeList(data.quantityTypes)
      props.dispatch(stopLoading())
    },
    onError: (error) => {
      onError(formatErrors(error))
      props.dispatch(stopLoading())
    },
  })

  // eslint-disable-next-line no-unused-vars
  const [componentGroups, resComponentGroups] = useLazyQuery(GET_COMPONENT_GROUPS, {
    fetchPolicy: 'cache-and-network',
    onCompleted: (data) => {
      setComponentGroupList(data.componentGroups)
      props.dispatch(stopLoading())
    },
    onError: (error) => {
      onError(formatErrors(error))
      props.dispatch(stopLoading())
    },
  })

  // eslint-disable-next-line no-unused-vars
  const [addComponentGroup, resAddComponentGroup] = useMutation(ADD_COMPONENT_GROUP, {
    //refetchQueries: ["getComponentTypes"],
    onCompleted: (data) => {
      props.dispatch(stopLoading())
      //Appcues.track("Component type Info saved");
      addComponentGroupModal.current.handleClose()
      onSuccess('New component group saved')
      fetchApi()
    },
    onError: (error) => {
      onError(formatErrors(error))
      props.dispatch(stopLoading())
    },
  })

  // eslint-disable-next-line no-unused-vars
  const [updateComponentGroup, resUpdateComponentGroup] = useMutation(UPDATE_COMPONENT_GROUP, {
    //refetchQueries: props.refetchQueries,
    onCompleted: (data) => {
      setIsUpdateCompleted(true)
      props.dispatch(stopLoading())
      //Appcues.track("Component type Info saved");
      onSuccess('Component group Info saved')
    },
    onError: (error) => {
      onError(formatErrors(error))
      props.dispatch(stopLoading())
    },
  })

  // eslint-disable-next-line no-unused-vars
  const [deleteComponentGroup, resDeleteComponentType] = useMutation(DELETE_COMPONENT_GROUP, {
    //refetchQueries: ["getComponentTypes"],
    onCompleted: (data) => {
      props.dispatch(stopLoading())
      deleteModal.current.handleClose()
      //Appcues.track("Component type Info saved");
      onSuccess('Component group deleted')
      fetchApi()
    },
    onError: (error) => {
      onError(formatErrors(error))
      props.dispatch(stopLoading())
    },
  })

  React.useEffect(() => {
    fetchApi()
  }, [])

  const fetchApi = () => {
    props.dispatch(startLoading())
    setComponentGroupList([])
    componentGroups({
      variables: {},
    })
  }

  const onError = (message) => props.dispatch(openErrorMessage(message))
  const onSuccess = (message) => props.dispatch(openSuccessMessage(message))

  const validateComponentGroup = (data) => {
    if (!data.name) {
      onError('Please enter component group name')
      return false
    }
    if (!data.quantityType) {
      onError('Please enter component group quantity type')
      return false
    }
    return true
  }

  const onSave = (data, afterOnSave) => {
    if (validateComponentGroup(data)) {
      setIsUpdateCompleted(false)
      const input = {
        id: data.id,
        name: data.name,
        active: data.active,
        quantityType: data.quantityType,
      }
      props.dispatch(startLoading())
      updateComponentGroup({ variables: { input } })
    }
  }

  const addComponentGroupApiCall = (data) => {
    props.dispatch(startLoading())
    addComponentGroup({ variables: { input: data } })
  }

  const openDeleteModal = (item) => (e) => {
    setSelectedItemToDelete(item)
    deleteModal.current.handleClickOpen()
  }

  const onDeleteItem = (e) => {
    props.dispatch(startLoading())
    deleteComponentGroup({ variables: { id: selectedItemToDelete.id } })
  }

  return (
    <div>
      <Grid container>
        <Grid className="addButton" item xs={12} sm={12} md={12} lg={12}>
          {permitted ? (
            <Button
              variant="raised"
              className="primary-button pull-right margin-bottom-small"
              onClick={() => addComponentGroupModal.current.handleClickOpen()}
            >
              Add Component Group
            </Button>
          ) : null}
        </Grid>
      </Grid>
      <Grid container>
        <Grid className="unversalScroll" item xs={12} sm={12} md={12} lg={12}>
          <Paper>
            <div className="table-scroll">
              <Table>
                <TableHead>
                  {columns && columns.map((col) => <TableCell>{col}</TableCell>)}
                </TableHead>
                <TableBody>
                  {componentGroupList &&
                    componentGroupList.length > 0 &&
                    componentGroupList.map((data, index) => (
                      <ComponentGroupListItemEditable
                        key={index}
                        dataToEdit={data}
                        onSave={onSave}
                        isUpdateCompleted={isUpdateCompleted}
                        onDelete={openDeleteModal(data)}
                        quantityTypeList={quantityTypeList}
                      />
                    ))}
                </TableBody>
              </Table>
            </div>
          </Paper>
        </Grid>
      </Grid>
      <AddComponentGroupModal
        ref={addComponentGroupModal}
        addComponentGroup={addComponentGroupApiCall}
        onError={onError}
        quantityTypeList={quantityTypeList}
      />
      <ModalDialog ref={deleteModal} onConfirm={onDeleteItem} confirmText="delete">
        Are you sure you want to delete '{selectedItemToDelete.name}'
      </ModalDialog>
    </div>
  )
}

export default connect(({ dispatch, shopReducer }) => ({
  dispatch,
  shopReducer,
}))(ContainerWithTitle(ComponentGroups, 'Component Groups'))



// WEBPACK FOOTER //
// ./src/containers/Settings/Manufacturing/ComponentGroups.js